import React, { useState } from "react";
import "./ourservice.css";
import blueArrow from "../../Media/bluearrow.svg";
import retail from "../../Media/retail.jpg";
import education from "../../Media/education.jpg";
import healthcare from "../../Media/healthcare.webp";
import realEstate from "../../Media/real estate.webp";
import manufacturing from "../../Media/manufacturing.jpg";
import media from "../../Media/media.webp";
import banking from "../../Media/banking.jpg";
import lifescience from "../../Media/lifescience.webp";
import { GoChevronDown, GoChevronUp } from "react-icons/go";

const servicesData = [
  {
    id: "realEstate",
    title: "Real Estate",
    image: realEstate,
    headingClass: "heading3",
    subheadingClass: "subheading3",
    imgClass: "img-first",
    cardClass: "service-one",
    initialText:
      "Transforming property management with cutting-edge digital solutions for seamless transactions and enhanced customer experiences.",
    fullText:
      " Our solutions help real estate businesses streamline property listings, manage leads, simplify customer interactions, and improve overall operational efficiency. From property management platforms and real estate websites to mobile applications and digital marketing solutions, we empower businesses with technology that drives growth, improves engagement, and creates a seamless experience for both businesses and customers.",
  },
  {
    id: "education",
    title: "Education",
    image: education,
    headingClass: "heading4",
    subheadingClass: "subheading4",
    imgClass: "img-second",
    cardClass: "service-two",
    initialText:
      "Empowering learning with smart technology, making education more accessible, engaging, and effective.",
    fullText:
      " Our digital solutions help educational institutions streamline admissions, manage student information, simplify administrative processes, and improve communication between students, parents, and staff. From education management software and websites to mobile applications and customized digital solutions, we enable schools, colleges, and educational organizations to enhance their operations and deliver better learning experiences. By integrating innovative technology into education, we help institutions improve efficiency, strengthen engagement, and create seamless digital experiences for learners and educators.",
  },
  {
    id: "manufacturing",
    title: "Manufacturing",
    image: manufacturing,
    headingClass: "heading5",
    subheadingClass: "subheading5",
    imgClass: "img-three",
    cardClass: "service-three",
    initialText:
      "Driving efficiency and innovation through automation, IoT, and AI-powered solutions for the modern industry.",
    fullText:
      " Our digital solutions help manufacturing businesses streamline operations, optimize production processes, monitor performance, and improve overall productivity. From customized software and smart automation to IoT-enabled systems and AI-driven solutions, we help manufacturers reduce manual effort, improve decision-making, and manage their operations more efficiently. By integrating advanced technologies into manufacturing workflows, businesses can enhance quality, minimize downtime, and achieve sustainable growth in a competitive market.",
  },
  {
    id: "media",
    title: "Communication & Media",
    image: media,
    headingClass: "heading6",
    subheadingClass: "subheading6",
    imgClass: "img-four",
    cardClass: "service-four",
    initialText:
      "Revolutionizing content delivery and audience engagement with advanced digital platforms and analytics.",
    fullText:
      " We help media and communication businesses streamline content management, enhance audience interactions, and deliver personalized digital experiences across multiple channels. From media websites and content management platforms to mobile applications, social media solutions, and data-driven analytics, our technology solutions enable organizations to expand their digital reach, improve engagement, and stay ahead in the rapidly evolving media landscape.",
  },
  {
    id: "healthcare",
    title: "Healthcare",
    image: healthcare,
    headingClass: "heading7",
    subheadingClass: "subheading7",
    imgClass: "img-five",
    cardClass: "service-five",
    initialText:
      "Enhancing patient care with secure, AI-driven healthcare solutions for better diagnostics and management.",
    fullText:
      " Our digital solutions help healthcare organizations streamline patient management, improve operational efficiency, and simplify healthcare processes. From customized healthcare software and mobile applications to AI-powered solutions and secure data management systems, we help clinics, hospitals, and healthcare providers deliver better patient experiences. By leveraging modern technologies, we enable healthcare businesses to improve decision-making, manage patient information securely, optimize workflows, and provide more efficient and accessible healthcare services.",
  },
  {
    id: "banking",
    title: "Banking",
    image: banking,
    headingClass: "heading8",
    subheadingClass: "subheading8",
    imgClass: "img-six",
    cardClass: "service-six",
    initialText:
      "Redefining financial services with secure, data-driven solutions for seamless transactions and customer-centric banking.",
    fullText:
      " Our digital solutions help banks and financial institutions streamline operations, improve transaction efficiency, and deliver secure digital banking experiences. From customized banking software and mobile applications to data analytics and automated solutions, we empower financial organizations to manage services more effectively and enhance customer engagement. By leveraging modern technologies, we help businesses improve operational efficiency, strengthen data security, simplify financial processes, and provide seamless, reliable banking experiences for their customers.",
  },
  {
    id: "retail",
    title: "Retail",
    image: retail,
    headingClass: "heading9",
    subheadingClass: "subheading9",
    imgClass: "img-seven",
    cardClass: "service-seven",
    initialText:
      "Elevating shopping experiences with personalized, AI-powered insights and omnichannel commerce solutions.",
    fullText:
      " Our digital solutions help retail businesses streamline operations, manage inventory, understand customer behavior, and deliver personalized shopping experiences across multiple channels. From e-commerce websites and mobile applications to AI-driven analytics and customized retail software, we empower businesses to connect with customers more effectively and improve overall efficiency. By leveraging modern technologies, we help retailers optimize their operations, enhance customer engagement, simplify transactions, and drive sustainable growth in a competitive marketplace.",
  },
  {
    id: "lifescience",
    title: "Life Science",
    image: lifescience,
    headingClass: "heading10",
    subheadingClass: "subheading10",
    imgClass: "img-eight",
    cardClass: "service-eight",
    initialText:
      "Accelerating innovation in pharmaceuticals and biotechnology with advanced research and data-driven solutions.",
    fullText:
      " Our digital solutions help life science organizations streamline research processes, manage complex data, and improve operational efficiency. From custom software development and data analytics to AI-powered solutions and secure digital platforms, we support pharmaceutical and biotechnology companies in making informed decisions and advancing innovation. By leveraging modern technologies, we help organizations optimize workflows, enhance research capabilities, manage critical information securely, and accelerate the development of innovative solutions for a better future.",
  },
];

const Ourservice = () => {
  const [showMore, setShowMore] = useState(false);
  const [expandedService, setExpandedService] = useState(null);

  const toggleAccordion = (id) => {
    setExpandedService((prev) => (prev === id ? null : id));
  };

 const renderServiceCard = (service) => {
    const isExpanded = expandedService === service.id;

    return (
      <div className={service.cardClass} key={service.id}>
        <img
          loading="lazy"
          className={service.imgClass}
          src={service.image}
          alt={service.id}
        />
        <h3 className={`${service.headingClass} who-we-are-animate`}>
          {service.title}
        </h3>        
        <p className={service.subheadingClass}>
          {isExpanded ? `${service.initialText}${service.fullText}` : service.initialText}
        </p>

        <button
          className="secondary"
          onClick={() => toggleAccordion(service.id)}
        >
          <span className="testing">
            {isExpanded ? "Show less" : "Know more"}
          </span>
          <img
            loading="lazy"
            className="response-arrow"
            src={blueArrow}
            alt=""
          />
        </button>
      </div>
    );
  };

  return (
    <section className="container-service">
      <div className="servicepage">
        <h2 className="heading2 who-we-are-animate">Our Services</h2>
        <p className="subheading2 who-we-are-animate">
          We provide cutting-edge IT solutions tailored to your business needs.
        </p>
      </div>

      <div className="service-section">
        {servicesData.slice(0, 4).map((service) => renderServiceCard(service))}
      </div>

      <div className={`extra-services ${showMore ? "open" : ""}`}>
        <div className="extra-services-inner">
          {servicesData.slice(4).map((service) => renderServiceCard(service))}
        </div>
      </div>

      <button className="Primary-two" onClick={() => setShowMore(!showMore)}>
        <span className="testing">{showMore ? "Show Less" : "Show More"}</span>
        {showMore ? (
          <GoChevronUp className="response-blackarrow" />
        ) : (
          <GoChevronDown className="response-blackarrow" />
        )}
      </button>
    </section>
  );
};

export default Ourservice;